import React from "react";
import { formatCurrencyFn, isEmpty } from "@util/utils";

const FeeRecord = (props) => {
	const { monthlyFee, contractMonthTerm } = props;
	return (
		<React.Fragment>
			月費 <span className="text-info">{formatCurrencyFn(monthlyFee, { symbol: '$' })}</span> x 合約月數{' '}
			<span className="text-info">{contractMonthTerm}</span>
		</React.Fragment>
	);
};

const ChangeFeeRecordsContent = ({sourceData}) => {
	const { contractMonthTerm, membership, changeFeeRecords } = sourceData || {};

	const handleChangeFeeRecords = (data, changeFeeRecords) => {
		let records = [];
		let currentRecord = {};
		let currentMonthlyFee = data.monthlyFee;
		let contractMonthTerm = data.contractMonthTerm;

		if (!isEmpty(changeFeeRecords)) {
			changeFeeRecords.forEach((item) => {
				let itemRecord = {
					monthlyFee: item.monthlyFee,
					contractMonthTerm: item.usedTotalMonth,
				};
				contractMonthTerm = contractMonthTerm - item.usedTotalMonth;

				records.push(itemRecord);
			});
		}
		currentRecord.monthlyFee = currentMonthlyFee;
		currentRecord.contractMonthTerm = contractMonthTerm;
		records.push(currentRecord);

		return records;
	};
	const feeRecords = handleChangeFeeRecords({ contractMonthTerm, ...membership }, changeFeeRecords);

	if (feeRecords.length > 1) {
		return (
			<React.Fragment>
				{feeRecords
					.map((item, i) => {
						return (
							<React.Fragment key={i}>
								<FeeRecord {...item} />
							</React.Fragment>
						);
					})
					.reduce((prev, curr) => [prev, ' + ', curr])}
			</React.Fragment>
		);
	}

	return (
		<React.Fragment>
			{feeRecords.map((item, i) => (
				<FeeRecord key={i} {...item} />
			))}
		</React.Fragment>
	);
};

export default ChangeFeeRecordsContent;